module.exports = __webpack_public_path__ + "static/media/airtel.8c8e00a3.png";